import { render, staticRenderFns } from "./SGPHomePageComponent.vue?vue&type=template&id=42eb88fc&scoped=true"
import script from "./SGPHomePageComponent.vue?vue&type=script&lang=js"
export * from "./SGPHomePageComponent.vue?vue&type=script&lang=js"
import style0 from "./SGPHomePageComponent.vue?vue&type=style&index=0&id=42eb88fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42eb88fc",
  null
  
)

export default component.exports